
import axios from 'axios'

export default {
    getOrderList({commit}, params){
        return axios.post('/api/background/canteen_order/list', params)
    },
    getRefundOrderList({commit}, params){
        return axios.post('/api/background/canteen_order/refund_order/list', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/order.js